// extracted by mini-css-extract-plugin
module.exports = {"editButton":"UpdateProfile_editButton__2Rjf7"};